import { getAge } from "./getAge";

// Eg city or county, name
$.validator.addMethod(
  "lettersonly",
  function (value, element) {
    return this.optional(element) || /^[a-z]+$/i.test(value);
  },
  "Letters only please"
);

// Eg for street address
$.validator.addMethod(
  "alphanumchar",
  function (value) {
    return /^[a-zA-Z 0-9,-]*$/.test(value);
  },
  "Please enter text or comma only"
);

// Matches UK postcode. Does not match to UK Channel Islands that have their own postcodes (non standard UK)
$.validator.addMethod(
  "postcodeUK",
  function (value, element) {
    return (
      this.optional(element) ||
      /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test(
        value
      )
    );
  },
  "Please specify a valid UK postcode"
);

// Matches DE postcodes - 5 digits
$.validator.addMethod(
  "postcodeDE",
  function (value, element) {
    return this.optional(element) || /^(\d{5})$/.test(value);
  },
  "Please specify a valid DE postcode"
);

// Matches AT postcodes - 4 digits
$.validator.addMethod(
  "postcodeAT",
  function (value, element) {
    return this.optional(element) || /^(\d{4})$/.test(value);
  },
  "Please specify a valid AT postcode"
);

// Matches DEAT postcodes - 4 or 5 digits
$.validator.addMethod(
  "postcodeDEAT",
  function (value, element) {
    return this.optional(element) || /\d{4,5}/.test(value);
  },
  "Please specify a valid AT postcode"
);

// Phone number prefix
$.validator.addMethod(
  "countryCode",
  function (value, element) {
    return this.optional(element) || /^(\+?\d{1,3}|\d{1,4})$/.test(value);
  },
  "Please specify a valid country code"
);

// Matches UK Phone number with optional zero prefix
$.validator.addMethod(
  "phoneWithOptionalZeroPrefixUK",
  function (value, element) {
    return (
      this.optional(element) ||
      /^0*(?:\d{2}\)?\s?\d{4}\s?\d{4}|\d{3}\)?\s?\d{3}\s?\d{3,4}|\d{4}\)?\s?(?:\d{5}|\d{3}\s?\d{3})|\d{5}\)?\s?\d{4,5})$/.test(
        value
      )
    );
  },
  "Please enter a valid phone number"
);

// Matches DEAT Phone number with optional zero prefix
$.validator.addMethod(
  "phoneWithOptionalZeroPrefixDEAT",
  function (value, element) {
    return this.optional(element) || /^0*\d{1,15}$/.test(value);
  },
  "Please enter a valid phone number"
);

// jQuery.validator.addMethod("day", function (value, element) {
//     if (this.optional(element)) return true;
//     return (/^[0-9]{2}[:.,-]?$/i.test(value)) && value <= 31;
//
// }, "Please enter a valid day.");
//
// jQuery.validator.addMethod("month", function (value, element) {
//     if (this.optional(element)) return true;
//     return (/^[0-9]{2}[:.,-]?$/i.test(value)) && value <= 12;
//
// }, "Please enter a valid month.");
//
// jQuery.validator.addMethod("year", function (value, element) {
//     if (this.optional(element)) return true;
//     return (/^[0-9]{4}[:.,-]?$/i.test(value));
//
// }, "Please enter a valid year. You must be 18 years or older.");

$.validator.addMethod("over18", function (value, element) {
  if (this.optional(element)) return true;
  // Convert to date object
  let date = new Date(value);
  // Check if it's a valid date and valid number
  const isValidDate = date instanceof Date && !isNaN(date.valueOf());
  // Check over 18
  const isOver18 = getAge(value) >= 18;
  // console.log(isValidDate && isOver18);
  // console.log(getAge(value) >= 18);
  return isValidDate && isOver18;
});

// Matches DEAT postcodes - 4 or 5 digits
$.validator.addMethod(
  "orvMembershipNumber",
  function (value, element) {
    // console.log("Running orv test");
    return this.optional(element) || /\d{6,7}/.test(value);
  },
  "Please enter a valid Bikecard number"
);
